import { render, staticRenderFns } from "./RiderMediaEdit.vue?vue&type=template&id=5443be01&lang=pug"
import script from "./RiderMediaEdit.vue?vue&type=script&lang=js"
export * from "./RiderMediaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports